import { ModalContextProvider } from 'utils/contexts/modal';

import { LoginContextProvider } from './contexts/LoginContextProvider';
import { IntegrationsContextProvider } from './contexts/IntegrationContextProvider';
import { IntegrationsPage } from './components/IntegrationsPage';

export const MovableInkIntegrations = () => {
  return (
    <ModalContextProvider>
      <LoginContextProvider>
        <IntegrationsContextProvider>
          <IntegrationsPage />
        </IntegrationsContextProvider>
      </LoginContextProvider>
    </ModalContextProvider>
  );
};
